import React from 'react'

interface HomePrevButtonProps {
  onClick: () => void
  className?: string
}

export const HomePrevButton: React.FC<HomePrevButtonProps> = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center h-12 w-12 rounded-full bg-black/80 backdrop-blur-sm border-white/20 text-white hover:bg-black/90 hover:scale-110 transition-all duration-300 border-2 border-white ${className}`}
    >
      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.16667 2L2 9.16667L9.16667 16.3333"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
